import DatePicker from 'react-datepicker';
import events from 'lib/events';
import Loader from 'components/loader';
import moment from 'moment';
import Pagination from 'components/layout/pagination';
import EditableDatePicker from 'components/forms/editableDatePicker';
import phoneFormat from 'util/phoneformat';
import PrintableFullReport from '../components/printableFullReport';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReportApi from 'api/report';
import ReportDropDown from '../components/reportDropDown';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {reportDateFormat, dateTimeFormats} from 'helpers/constants';
import ReportSummaryErrorHandler from '../components/reportSummaryErrorHandler';
import {makeCancelable} from 'helpers/cancelablePromise';
import ValidationGroup from 'helpers/validation';
import {getValidDateBoundary} from 'helpers/dateHelper';

const filterOptions = {
  branch: -1,
  branchOptions: [
    {
      value: -1,
      label: 'All Stores',
    },
  ],
  poolType: -1,
  poolTypeOptions: [],
};

const _MissinCustomerReportDetailedView = (props) => {
  const {report, page, count, total, onPageChange, formatMessage, emailColumn} = props;

  return <div className='pad-top'>
    <table className='table-biolab table-striped past-due-table'>
      <thead style={{fontSize: '13px'}}>
        <tr>
          <th style={{width: '150px'}}><FormattedMessage id="general.primary.contact"/></th>
          <th><FormattedMessage id="general.primary.phone"/></th>
          <th style={{width: '130px'}}><FormattedMessage id="general.email.address"/></th>
          <th><FormattedMessage id="general.last.analysis"/></th>
          <th><FormattedMessage id="general.next.analysis"/></th>
          <th><FormattedMessage id="general.water.tester"/></th>
          <th style={{width: '170px', paddingTop: '10px'}}>
            <FormattedMessage id="general.system.email"/>
            <ToolTip title={formatMessage({id: 'reports.missing.customer.tooltip'})}
                   position={tooltipPositions.topRight}
                   iconOnly
                   invert/>
          </th>
        </tr>
      </thead>
      <tbody>
        {report.map(row => {
          let customerLink = `#customer/${row.CustomerID}`;
          let analysisLink = `#customer/${row.CustomerID}/${row.PoolID}/analysis/report/history/${row.AnalysisID}/print`;

          return <tr key={row.PoolID}>
            <td>
              <a href={customerLink}>{row.FullName}</a>
            </td>
            <td>{row.HomePhone}</td>
            <td>{row.Email}</td>
            <td>
              <a href={analysisLink}> {moment(row.PrevAnalysisDate, 'DD-MM-YYYY').format(dateTimeFormats.numeralDate)}</a>
            </td>
            <td>{moment(row.NextAnalysisDate).format(dateTimeFormats.numeralDate)}</td>
            <td>{row.WaterTester}</td>
            <td>
              {emailColumn(row, formatMessage)}
            </td>
          </tr>;
        })}
      </tbody>
    </table>
    <div className='center-pagination'>
      <Pagination
        onPageChange={onPageChange}
        page={page}
        count={count}
        total={total} />
    </div>
  </div>;
};

_MissinCustomerReportDetailedView.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  formatMessage: PropTypes.func.isRequired,
  report: PropTypes.object.isRequired,
  emailColumn: PropTypes.func.isRequired,
};


class MissingCustomerReport extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    let {formatMessage} = this.props.intl;
    const _filterOptions = Object.assign({}, filterOptions);
    const branchesFilterable = this.props.branches.map(b => {
      return {
        value: b.id,
        label: b.name,
      };
    });

    _filterOptions.branchOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.stores'}),
      }, ...branchesFilterable];

    _filterOptions.poolTypeOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.systems'}),
      },
      {
        value: 1,
        label: formatMessage({id: 'general.pools'}),
      },
      {
        value: 2,
        label: formatMessage({id: 'general.spas'}),
      },
      {
        value: 3,
        label: formatMessage({id: 'general.swim.spas'}),
      },
    ];

    this.state = {
      loaded: true,
      summary: null,
      report: null,
      start: moment().startOf('month').subtract(1, 'years'),
      end: moment(),
      since: moment().startOf('year'),
      branches: this.props.branches.map(b => b.id),
      page: 1,
      ..._filterOptions,
      count: 0,
      total: 0,
      showNoDataMessage: false,
      error: false,
    };
  }

  componentWillMount() {
    this.group = new ValidationGroup(this._updateReport);
  }

  componentWillUnmount() {
    this.setState({
      filterOptions: {},
    });
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  onPageChange = (page, event) => {
    const {count, fullReport} = this.state;

    const first = (page - 1) * count;
    const last = first + count;

    const pagReport = fullReport.slice(first, last);

    this.setState({
      report: pagReport,
      page: page,
    });
  };


  exportReport = () => {
    const {start, end, since, branch, poolType, branches} = this.state;

    ReportApi.getMissingCustomersReportExport(
      this.props.intl.locale,
      branch === -1 ? branches : branch,
      start.format(), end.format(), since.format(),
      poolType === -1 ? null : poolType);
  };

  emailColumn(report, formatMessage) {
    let FollowUpDate = report['FollowUpDate'] ? moment.utc(report['FollowUpDate']) : '';

    if (!report.Email || report.Email.trim() === '') {
      return <div><i className='bl bl-attention red'/> {formatMessage({id: 'general.no.email'})}</div>;
    }
    if (!FollowUpDate || FollowUpDate.isAfter(moment.utc())) {
      return <div><i className='bl bl-attention red'/> {formatMessage({id: 'general.email.not.sent'})}</div>;
    }
    if (!report['Emailed'] && FollowUpDate.isBefore(moment.utc())) {
      return <div><i className='bl bl-opted-out'/> {formatMessage({id: 'general.email.opted.out'})}</div>;
    }
    return <div>{FollowUpDate.format(dateTimeFormats.numeralDate)}</div>;
  };

  printReport = () => {
    let {formatMessage} = this.props.intl;
    const {summary, start, end, since, fullReport} = this.state;
    const columns = [
      {name: formatMessage({id: 'general.total.accounts'}), key: 'totalAccounts'},
      {name: formatMessage({id: 'general.total.systems'}), key: 'totalSystems'},
      {name: formatMessage({id: 'general.total.pools'}), key: 'totalPools'},
      {name: formatMessage({id: 'general.in.ground.pools'}), key: 'inGroundPools'},
      {name: formatMessage({id: 'general.above.ground.pools'}), key: 'aboveGroundPools'},
      {name: formatMessage({id: 'general.splasher.pools'}), key: 'splasherPools'},
      {name: formatMessage({id: 'general.swim.spas'}), key: 'swimSpas'},
      {name: formatMessage({id: 'general.spas'}), key: 'spas'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'maintenanceSystems'},
    ];
    const tableColumns = [
      {name: formatMessage({id: 'general.primary.contact'}), key: 'FullName'},
      {name: formatMessage({id: 'general.primary.phone'}), key: 'HomePhone'},
      {name: formatMessage({id: 'general.email.address'}), key: 'Email'},
      {
        name: formatMessage({id: 'general.last.analysis'}),
        key: 'PrevAnalysisDate',
        format: i => moment(i, 'DD-MM-YYYY').format(dateTimeFormats.numeralDate),
      },
      {
        name: formatMessage({id: 'general.next.analysis'}),
        key: 'NextAnalysisDate',
        format: i => moment(i, 'DD-MM-YYYY').format(dateTimeFormats.numeralDate),
      },
      {name: formatMessage({id: 'general.water.tester'}), key: 'WaterTester'},
      {name: formatMessage({id: 'general.system.email'}), key: 'SystemEmail'},
    ];

    fullReport.forEach(element => {
      element.SystemEmail = this.emailColumn(element, formatMessage);
    }, this);
    console.log(fullReport);
    return <PrintableFullReport
      start={start.format(dateTimeFormats.numeralDate)}
      startLabel={formatMessage({id: 'general.start.date'})}
      end={end.format(dateTimeFormats.numeralDate)}
      endLabel={formatMessage({id: 'general.end.date'})}
      formatMessage={formatMessage}
      since={since.format(dateTimeFormats.numeralDate)}
      sinceMessage={'Not Tested Since'}
      summaryColumns={columns}
      summaryData={summary}
      tableColumns={tableColumns}
      tableData={fullReport}
      title={formatMessage({id: 'reports.followups.missing.customers'})}
    />;
  };

  resetFilters = () => {
    this.setState({
      branch: -1,
      customerType: '',
      poolType: -1,
      start: moment().set({'year': 1986, 'month': 0, 'date': 1}),
      end: moment(),
      page: 1,
    });
  };

  componentDidCatch(error, errorInfo) {
    console.log(error,errorInfo);
    this.setState({
      error: true,
    });

  }

  _updateReport = () => {
    const {branch, start, end, since, poolType, branches, page} = this.state;

    this.setState({
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        summary: null,
        report: null,
      });
    }

    let apis = [];

    apis.push(ReportApi.getMissingCustomersReportSummary(
      branch === -1 ? branches : branch,
      start.format(), end.format(), since.format(),
      poolType === -1 ? null : poolType)
    );
    apis.push(ReportApi.getMissingCustomersReport(
      branch === -1 ? branches : branch,
      start.format(), end.format(), since.format(),
      poolType === -1 ? null : poolType, page));

    (this.fetching = makeCancelable(Promise.all(apis)))
    .then(([summary, reportData]) => {
      if (reportData.report) {
        let {formatMessage} = this.props.intl;

        for (let row of reportData.report) {
          row.FullName = row.NameFirst + ' ' + row.NameLast;
          row.HomePhone = row.HomePhone ? phoneFormat(row.HomePhone) : '';
          if (!row.Email || row.Email.trim() === '') {
            row.EmailString = formatMessage({id: 'general.no.email'});
          } else if (row.PastDue === false) {
            row.EmailString = formatMessage({id: 'general.email.opted.out'});
          } else if (row.PastDueNotify === true) {
            row.EmailString = formatMessage({id: 'general.email.sent'});
          } else {
            row.EmailString = formatMessage({id: 'general.email.not.sent'});
          }
          if (row.NextAnalysisDate) {
            row.NextAnalysisDate = moment(row.NextAnalysisDate).format(dateTimeFormats.numeralDate);
          }
          if (row.PrevAnalysisDate) {
            row.PrevAnalysisDate = moment(row.PrevAnalysisDate).format(dateTimeFormats.numeralDate);
          }
        }
      }

      if (summary && summary.totalAccounts > 0) {
        const report = reportData.report.slice(0, 20);

        this.setState({
          summary: summary,
          fullReport: reportData.report,
          report,
          total: reportData.report.length,
          count: 20,
          page: 1,
          showNoDataMessage: false,
          error: false,
        });
      } else {
        this.setState({showNoDataMessage: true, error: false});
      }
      this.setState({loaded: true});

    }).catch(err => {
      console.log(err);
      if (err && err.canceled) {return;}
      this.setState({loaded: true, error: true, report: null, summary: null});
    });
  };

  render() {
    let {formatMessage} = this.props.intl;
    const {start, end, since, summary, loaded, branch, branchOptions, poolType, poolTypeOptions, report, showNoDataMessage} = this.state;

    return <div className='report-container past-due-report'>
      <div className='description'>
        <p><FormattedMessage id="reports.missing.customer.descriptionone"/></p>
        <p><FormattedMessage id="reports.missing.customer.descriptiontwo"/></p>
      </div>
      <div className='report-options'>
        <div className='top-title-bar'>
          <FormattedMessage id="general.report.options"/>
        </div>
        <div className='select-options container'>
          <div className='row'>
            <div className='col-sm-3'>
              <div className='form-group'>
                <label><FormattedMessage id="reports.tested.between"/> <br/>
                  <FormattedMessage id="general.date.from"/>
                </label>
                <EditableDatePicker
                    onChange={e => {
                      this.setState({start: e.value});
                    }}
                    dataKey={'start'}
                    group = {this.group}
                    value={start}
                    required={true}
                    editMode={true}
                    dateFormat={reportDateFormat}
                    maxDate={getValidDateBoundary(end, true).subtract(1, 'days')}/>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <label>
                  <FormattedMessage id="general.date.to"/>
                </label>
                <EditableDatePicker
                    onChange={e => {
                      this.setState({end: e.value});
                    }}
                    dataKey={'end'}
                    group = {this.group}
                    value={end}
                    required={true}
                    editMode={true}
                    dateFormat={reportDateFormat}
                    minDate={getValidDateBoundary(start)}
                    maxDate={getValidDateBoundary()}/>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <label><FormattedMessage id="reports.not.tested.date"/></label>
                <div className='editable-datepicker'>
                  <EditableDatePicker
                    onChange={e => {
                      this.setState({since: e.value});
                    }}
                    dataKey={'since'}
                    group = {this.group}
                    value={since}
                    required={true}
                    editMode={true}
                    dateFormat={reportDateFormat}
                    maxDate={getValidDateBoundary()}/>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-3'>
              <ReportDropDown value={branch}
                              label={formatMessage({id: 'general.store'})}
                              onChange={e => {
                                this.setState({branch: parseInt(e.target.value)});
                              }}
                              options={branchOptions}/>
            </div>
            <div className='col-sm-3'>
              <ReportDropDown value={poolType}
                              label={formatMessage({id: 'general.system.type'})}
                              onChange={e => {
                                this.setState({poolType: parseInt(e.target.value)});
                              }}
                              options={poolTypeOptions}/>
            </div>
          </div>
        </div>
        <div className='manage-options'>
          <div className='col-sm-12 button-group'>
            <span className='reset-button pull-right'
                  onClick={this.resetFilters}><FormattedMessage id="general.reset"/></span>
            <button className='btn btn-primary pull-right'
                    onClick={this.group.validate}><FormattedMessage id="reports.update.summary"/></button>
          </div>
        </div>
      </div>
      <Loader loaded={loaded}>
        <ReportSummaryErrorHandler error={this.state.error}>
          {summary ?
            <div className='col-sm-12 summary-container'>
              <div className='row'>
                <h2>
                  <FormattedMessage id="reports.report.summary"/>
                  <span className='summary-date'> | <FormattedMessage id="general.date.range.labelled"
                                                                    values={{
                                                                      start: start.format(dateTimeFormats.numeralDate),
                                                                      end: end.format(dateTimeFormats.numeralDate),
                                                                    }}/> | <FormattedMessage id="reports.not.tested.date"
                                                                                             values={{date: since.format(dateTimeFormats.numeralDate)}}/>
                  </span>
                </h2>
                <p className='description'><FormattedMessage id="reports.reveal.report.summary"/></p>
              </div>
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.total.accounts"/></label>
                  <div>{summary.totalAccounts}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.total.systems"/></label>
                  <div>{summary.totalSystems}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.total.pools"/></label>
                  <div>{summary.totalPools}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.in.ground.pools"/></label>
                  <div>{summary.inGroundPools}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.above.ground.pools"/></label>
                  <div>{summary.aboveGroundPools}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.splasher.pools"/></label>
                  <div>{summary.splasherPools}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.swim.spas"/></label>
                  <div>{summary.swimSpas}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.spas"/></label>
                  <div>{summary.spas}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='general.total.maintenance'/></label>
                  <div>{summary.maintenanceSystems}</div>
                </div>
              </div>
              {report && report.length > 0 ?
                <_MissinCustomerReportDetailedView
                  report={report} emailColumn={this.emailColumn} formatMessage={formatMessage}
                  page={this.state.page} count={this.state.count}
                  total={this.state.total} onPageChange={this.onPageChange}/> :
                <div className='pad-top'/>}
            </div> :
            <div className='summary-container'>
              <h2><FormattedMessage id="reports.report.summary"/></h2>
              <p><FormattedMessage id="reports.reveal.report.summary"/></p>
              {showNoDataMessage ?
                <label className='report-no-data'><FormattedMessage id="reports.error.no.results"/></label> : ''}
              <div className='container-fluid custom-container-margins'>
                <div/>
              </div>
            </div>}
        </ReportSummaryErrorHandler>
      </Loader>
      <div className='col-sm-12 button-group shift-right'>
        <button className='btn btn-default pull-right'
                disabled={summary === null}
                onClick={() => {
                  events.publish('print', this.printReport());
                }}><FormattedMessage id="reports.print.summary"/></button>
        <button className='btn btn-primary pull-right'
                onClick={this.exportReport}><FormattedMessage id="reports.export.report"/></button>
      </div>
    </div>;
  }
}

MissingCustomerReport.propTypes = {
  branches: PropTypes.any,
};

MissingCustomerReport.defaultProps = {
  branches: [],
};

export default injectIntl(MissingCustomerReport);
